import { makeStyles } from "@material-ui/core";
import { AUTH_CONTAINER_WIDTH } from "../../../../constants";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: AUTH_CONTAINER_WIDTH,
  },
  forgotPassword: {
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(18),
  },
}));

export default useStyles;
